import { StyleSheet, View } from 'react-native'
import { useTheme } from 'styled-components'
import PropTypes from 'prop-types'
import { ErrorMessage } from '../ErrorMessage/ErrorMessage'

const styles = StyleSheet.create({
  flex: { flex: 1 },
  top: { justifyContent: 'flex-start' },
  middle: { justifyContent: 'center' },
  bottom: { justifyContent: 'flex-end' },
})

export const ComponentError = ({
  flex = true,
  width,
  height,
  activityIndicator,
  horizontal = 'center',
  vertical = 'middle',
  background,
  style,
  ...props
}) => {
  const theme = useTheme()
  const backgroundColor = theme.colors[background]
  return (
    <View
      style={[
        flex && !height && styles.flex,
        styles[vertical],
        { width, height, backgroundColor },
        style,
      ]}
    >
      <ErrorMessage textAlign={horizontal} {...props} />
    </View>
  )
}

ComponentError.propTypes = {
  horizontal: PropTypes.oneOf(['left', 'center', 'right']),
  vertical: PropTypes.oneOf(['top', 'middle', 'bottom']),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Error)]),
}
